import { AxiosRequestConfig, AxiosResponse } from "axios";
import Employee from "../components/Employees/Employee";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";
import { updateSession } from "./securityService";

export const logInService = (loginCredentials: {
  email: string;
  password: string;
}): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.signIn, loginCredentials);
};

export const signUpService = (signUpRequest: any): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.signUp, signUpRequest);
};

export const checkGMUser = (username: string): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      email: username,
    },
  };
  return axiosAuth.get(API_PATH().apis.checkGMUser, config);
};

export const sendOtpService = (
  sendOtpRequest: any,
  resendOTP: boolean
): Promise<AxiosResponse> => {
  return axiosAuth.post(
    resendOTP ? API_PATH().apis.resendOTP : API_PATH().apis.emailAuthOtp,
    sendOtpRequest
  );
};

export const registerStoreUserOtpService = (
  registerStoreUserOtpObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(
    API_PATH().apis.verifyUserRegister,
    registerStoreUserOtpObject
  );
};
export const forgotPasswordOtpService = (
  registerStoreUserOtpObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(
    API_PATH().apis.forgotPassword,
    registerStoreUserOtpObject
  );
};
export const resetPasswordService = (
  resetPasswordServiceObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(
    API_PATH().apis.resetPassword,
    resetPasswordServiceObject
  );
};

export const editProfileService = (
  editProfileObject: any
): Promise<AxiosResponse> => {
  console.log("api data: ", editProfileObject);
  return axiosAuth.put(API_PATH().apis.userProfile, editProfileObject);
};
export const getUserEnabledStatus = (
  username?: string | null,
  isEmployee?: string
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      username: username || localStorage.getItem("userName"),
      accountType: localStorage.getItem("accountType"),
    },
  };
  if (isEmployee) {
    config.params.type = "Employee";
  }
  return axiosAuth.get(API_PATH().apis.userOnboardingStatus, config);
};

export const getUserFromURLKey = (
  key?: string | null
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      key: key,
    },
  };
  return axiosAuth.get(API_PATH().apis.urlVerification, config);
};

export const getAppAuthSecret = (userName: string): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      userName: userName,
    },
  };
  return axiosAuth.get(API_PATH().apis.generateAppAuthQR, config);
};

export const verifyAndSetAppAuth = (
  verifyAndSetAppAuthObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(
    API_PATH().apis.verifyAndSetAppAuth,
    verifyAndSetAppAuthObject
  );
};

export const verifyEmployeeAndSetPassword = (
  userObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.put(API_PATH().apis.urlVerification, userObject);
};

export const viewProfileService = (): Promise<AxiosResponse> => {
  let url = new URL(API_PATH().apis.userProfile);
  return axiosAuth.get(url.href);
};

export const verify2FAAuthOTP = (
  verifyOTPAuthRequest: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.verify2FAAuthOTP, verifyOTPAuthRequest);
};

export const logout = async () => {
  const token = localStorage.getItem("token") || "";
  if (token) {
    const sessionId = JSON.parse(atob(token?.split(".")[1])).iss.sessionId;
    if (sessionId?.length) {
      const res = await updateSession({ sessionId }, null);
      localStorage.removeItem("user");
      localStorage.removeItem("Authorization");
      localStorage.removeItem("username");
      const ufCpompleted = localStorage.getItem("uf_completed") || "";
      const tours = localStorage.getItem("tours") || "";
      const ufReportsToSend = localStorage.getItem("uf_reports_to_send") || "";
      const ufSmartTips = localStorage.getItem("uf_smartTips") || "";
      const checkListsRedirects =
        localStorage.getItem("checklistsRedirects") || "";
      const checkListsDismiss = localStorage.getItem("checklistsDismiss") || "";
      localStorage.clear();
      localStorage.setItem("uf_completed", ufCpompleted);
      localStorage.setItem("tours", tours);
      localStorage.setItem("uf_reports_to_send", ufReportsToSend);
      localStorage.setItem("uf_smartTips", ufSmartTips);
      localStorage.setItem("checklistsRedirects", checkListsRedirects);
      localStorage.setItem("checklistsDismiss", checkListsDismiss);
    }
  }
};
